'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _rollupPluginBabelHelpers = require('../../../../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var classNames = _interopDefault(require('classnames/dedupe'));
var Icon = require('../../01.atoms/Icon/Icon.js');
var Expandable = require('../../01.atoms/Expandable/Expandable.js');
var Headline = require('../../01.atoms/Headline/Headline.js');
var TextExpandable = require('../TextExpandable/TextExpandable.js');
require('./_index.scss.js');

var CLASSNAME = 'varta-headline-expandable',
    cnExpanded = "".concat(CLASSNAME, "--expanded"),
    cnDark = "".concat(CLASSNAME, "--dark"),
    cnBody = "".concat(CLASSNAME, "__body"),
    cnWrapperTitle = "".concat(CLASSNAME, "__wrapper-title"),
    cnTitle = "".concat(CLASSNAME, "__title"),
    cnWrapperInner = "".concat(CLASSNAME, "__wrapper-inner"),
    cnButton = "".concat(CLASSNAME, "__button"),
    cnIcon = "".concat(CLASSNAME, "__icon");
/**
 * 
 */

var HeadlineExpandable = /*#__PURE__*/function (_TextExpandable) {
  _rollupPluginBabelHelpers.inherits(HeadlineExpandable, _TextExpandable);

  var _super = _rollupPluginBabelHelpers.createSuper(HeadlineExpandable);

  function HeadlineExpandable() {
    var _thisSuper, _this;

    _rollupPluginBabelHelpers.classCallCheck(this, HeadlineExpandable);

    for (var _len = arguments.length, props = new Array(_len), _key = 0; _key < _len; _key++) {
      props[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(props));
    _this.state = _rollupPluginBabelHelpers.objectSpread2(_rollupPluginBabelHelpers.objectSpread2({}, _rollupPluginBabelHelpers.get((_thisSuper = _rollupPluginBabelHelpers.assertThisInitialized(_this), _rollupPluginBabelHelpers.getPrototypeOf(HeadlineExpandable.prototype)), "state", _thisSuper)), {}, {
      expanded: _this.props.expanded
    });
    return _this;
  }

  _rollupPluginBabelHelpers.createClass(HeadlineExpandable, [{
    key: "render",
    value: function render() {
      var _classNames;

      var _this$props = this.props,
          className = _this$props.className,
          children = _this$props.children,
          iconId = _this$props.iconId,
          title = _this$props.title,
          dark = _this$props.dark,
          levelHeadline = _this$props.levelHeadline,
          _this$state = this.state,
          expanded = _this$state.expanded,
          notExpandable = _this$state.notExpandable,
          classes = [CLASSNAME, className],
          icon = expanded ? 'times' : 'caret-down-light';
      return /*#__PURE__*/React__default.createElement("div", {
        className: classNames(classes, (_classNames = {}, _rollupPluginBabelHelpers.defineProperty(_classNames, cnExpanded, expanded), _rollupPluginBabelHelpers.defineProperty(_classNames, cnDark, dark), _classNames))
      }, /*#__PURE__*/React__default.createElement("div", {
        className: cnWrapperTitle,
        onClick: this.toggleExpandState
      }, /*#__PURE__*/React__default.createElement(Headline, {
        className: cnTitle,
        iconId: iconId,
        level: levelHeadline
      }, title), !notExpandable && /*#__PURE__*/React__default.createElement("button", {
        className: cnButton,
        role: "button",
        "aria-label": "Expand Text"
      }, /*#__PURE__*/React__default.createElement(Icon, {
        size: "sm",
        className: cnIcon,
        id: icon
      }))), /*#__PURE__*/React__default.createElement(Expandable, {
        className: cnBody,
        classNameContent: cnWrapperInner,
        expanded: expanded,
        onMount: this.onExpandableMount,
        overlay: false
      }, children, !notExpandable && /*#__PURE__*/React__default.createElement("button", {
        className: classNames(cnButton, 'hidden-md-up'),
        role: "button",
        "aria-label": "Expand Text",
        onClick: this.toggleExpandState
      }, /*#__PURE__*/React__default.createElement(Icon, {
        size: "sm",
        className: cnIcon,
        id: "caret-down-light"
      }))));
    }
  }]);

  return HeadlineExpandable;
}(TextExpandable);

_rollupPluginBabelHelpers.defineProperty(HeadlineExpandable, "MIN_HEIGHT", 0);
HeadlineExpandable.propTypes = {
  /** Child nodes */
  children: PropTypes.node.isRequired,

  /** Additional class name */
  className: PropTypes.string,

  /** True for dark styling */
  dark: PropTypes.bool,

  /** Id of icon to the left */
  iconId: PropTypes.string,

  /** Level of headline e.g. 1 for h1 */
  levelHeadline: PropTypes.number,

  /** Title string */
  title: PropTypes.string.isRequired
};
HeadlineExpandable.defaultProps = _rollupPluginBabelHelpers.objectSpread2({}, TextExpandable.defaultProps);

module.exports = HeadlineExpandable;
